var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6758 2.14453C20.0977 3.62109 20.0977 6.78516 20.0977 6.78516C20.0977 6.78516 20.0977 9.91406 19.6758 11.4258C19.4648 12.2695 18.7969 12.9023 17.9883 13.1133C16.4766 13.5 10.5 13.5 10.5 13.5C10.5 13.5 4.48828 13.5 2.97656 13.1133C2.16797 12.9023 1.5 12.2695 1.28906 11.4258C0.867188 9.91406 0.867188 6.78516 0.867188 6.78516C0.867188 6.78516 0.867188 3.62109 1.28906 2.14453C1.5 1.30078 2.16797 0.632812 2.97656 0.421875C4.48828 0 10.5 0 10.5 0C10.5 0 16.4766 0 17.9883 0.421875C18.7969 0.632812 19.4648 1.30078 19.6758 2.14453ZM8.53125 9.63281L13.5234 6.78516L8.53125 3.9375V9.63281Z",
    fill: "#FC0404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f24ff0f728a6f32fc3f7b75cac2456ae.svg";
export { ForwardRef as ReactComponent };